import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import How from "./How";
import Brain from "./Brain";
import Models from "./Models";
import Footer from "./Footer";
import DataSecurity from "./DataSecurity";
import TrainModel from "./TrainModel";
import DepLearn from "./DepLearn";
import Paper from "./Paper";

const MainFrameHome = () => {
    return (
        <div className="main_frame">
            <Navbar />
            <Hero />
            <Paper/>
            <Brain/>
            <How/>
            <DataSecurity/>
            <TrainModel/>
            <DepLearn/>
            <Models/>
            <Footer/>
        </div>
    )
}

export default MainFrameHome